import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import {
  getFirestore,
  addDoc,
  getDoc,
  getDocs,
  updateDoc,
  collection,
  doc,
  query,
  where,
  orderBy,
  Timestamp,
} from "@firebase/firestore/lite";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  updateMetadata,
  deleteObject,
} from "firebase/storage";

var firebaseConfig = {
  apiKey: "AIzaSyAWoZgiE-7BJlNSsFzW_UeMUYEVXMxAstk",
  authDomain: "vto.firebaseapp.com",
  databaseURL: "https://vto.firebaseio.com",
  projectId: "firebase-vto",
  storageBucket: "firebase-vto.appspot.com",
  messagingSenderId: "448810098823",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export {
  getAuth,
  signInWithCustomToken,
  db,
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  orderBy,
  Timestamp,
  storage,
  ref,
  uploadBytes,
  getDownloadURL,
  updateMetadata,
  deleteObject,
};
